import { useContext } from "react";
import { AutocompleteInput, Create, FormTab, PasswordInput, ReferenceInput, required, TabbedForm, TextInput, useNotify } from "react-admin";
import MaskedInput from "../../components/masked-input";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const UserContextCreate = (props) => {

    const notify = useNotify();
    const context = useContext(AppContext)


    const onError = (error) => {
        notify('Já existe um usuário com o email informado', 'error')
    }

    const validatePassword = (value, allValues, props) => {
        return value === allValues.password ? undefined : 'As senhas devem coincidir'
    }

    const emailHelperText = 'Para melhor utilização do sistema de notificações via email, não recomendamos a utilização de endereços de email @outlook, @hotmail e @live.';


    return (
        <Create {...props} title={'Novo usuário'} onFailure={onError}>
            <TabbedForm>
                <FormTab label={'Dados Gerais'}>
                    <TextInput source="name" label={'Nome'} fullWidth validate={[required()]} isRequired />
                    <TextInput source="email" label={'Email'} type={'email'} validate={[required()]} isRequired fullWidth helperText={emailHelperText} />
                    <MaskedInput source="phone" onlyNumbers={true} mask={'(99) 99999-9999'} label={'Telefone'} fullWidth />
                    <PasswordInput source="password" label={'Senha'} fullWidth />
                    <PasswordInput source="passwordConfirmation" label={'Confirme a senha'} validate={validatePassword} fullWidth />

                    <ReferenceInput
                        source="profile"
                        label="Perfil"
                        reference="profiles"
                        sort={{ field: "name", order: "ASC" }}
                        filterToQuery={text => ({ "profile.name": text })}
                        validate={[required()]} fullWidth
                    >
                        <AutocompleteInput source="name" resettable 
                            options={{
                                suggestionsContainerProps: {
                                    modifiers: {
                                        computeStyle: { enabled: true, gpuAcceleration: false, },
                                        applyStyle: { enabled: true, },
                                    },
                                }
                            }} fullWidth />
                    </ReferenceInput>

                    {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && (
                        <ReferenceInput label="Unidade" source="institution_branch" reference="institution-branches" perPage={999}
                            sort={{ field: "name", order: "ASC" }} filterToQuery={text => ({ "institution_branch.name": text })}
                            validate={[required()]} fullWidth>
                            <AutocompleteInput
                                source="name"
                                emptyText="Todos"
                                optionText={val => `${val?.institution?.name} - ${val?.name}`}
                                optionValue="id"
                                fullWidth
                            />
                        </ReferenceInput>)}

                </FormTab>
            </TabbedForm>
        </Create>
    )
}

export default UserContextCreate;